import React from 'react';
import {useTranslation} from "react-i18next";

import {priceFormatting} from "../../../utils/utils";
import { useQueryClient } from '@tanstack/react-query';

const ListDetailsOrder = ({ order }) => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    // get settings from react-query
    const settings = queryClient.getQueryData(["company-settings"]) || {};

    const currency = settings.currency?.title || "";

    return (
        <div className="py-2 align-middle inline-block min-w-full px-2 mb-2">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            {t('Menu Item')}
                        </th>
                        <th scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            {t('Status')}
                        </th>
                        <th scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            {t('QTY')}
                        </th>
                        {order.total?(
                            <th scope="col"
                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                {t('Price')}
                            </th>
                        ):null}

                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                    {order.items && order.items.map((item) => {

                        return (
                            <React.Fragment key={item.id}>
                                <tr>
                                    <td className="py-2">
                                        <div className="flex items-center ml-2">

                                            <div className="ml-4">
                                                <div className=" font-medium text-gray-900">
                                                    {item.name}
                                                </div>

                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-6 py-2 whitespace-nowrap">
                                        <div className="text-sm text-gray-900">
                                            {item.status}
                                        </div>
                                    </td>
                                    <td className="px-6 py-2 whitespace-nowrap">
                                        <div className="text-sm text-gray-900">
                                            {item.amount}
                                        </div>
                                    </td>
                                    {order.total?(
                                        <td>
                                            {currency} {(item.price * item.amount).toFixed(2)}
                                        </td>
                                    ):null}

                                </tr>

                                {item.modifiers.map((mod) => (
                                    <tr className="bg-gray-100" key={mod.id}>
                                        <td className="py-2">
                                            <div className="flex items-center ml-6">
                                                <div className="ml-2">
                                                    <div className="font-medium text-sm text-gray-900">
                                                        {mod.name}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <td></td>
                                        <td className="px-6 py-2 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                {item.amount}
                                            </div>
                                        </td>
                                        {order.total?(
                                            <td>
                                                {priceFormatting(mod.price, mod.tax_percent, item.amount)}
                                            </td>
                                        ):null}

                                    </tr>
                                ))}
                            </React.Fragment>
                        )
                    })}
                    </tbody>
                    {order.total ? (
                        <tfoot className="bg-gray-200">
                        <tr>
                            <td className="px-6 py-1 whitespace-nowrap">{t('Subtotal')}</td>
                            <td></td>
                            <td></td>
                            <td>{currency} {order.subtotal.toFixed(2)}</td>
                        </tr>
                        <tr>
                            <td className="px-6 py-1 whitespace-nowrap">{t('Tips')}</td>
                            <td></td>
                            <td></td>
                            <td>{currency} {order.tips.toFixed(2)}</td>
                        </tr>
                        <tr>
                            <td className="px-6 py-1 whitespace-nowrap">% {t('VAT')}</td>
                            <td></td>
                            <td></td>
                            <td>{currency} {order.tax.toFixed(2)}</td>
                        </tr>
                        {order.service_charge ? (
                            <tr>
                                <td className="px-6 py-1 whitespace-nowrap">{t('Service charge')}</td>
                                <td></td>
                                <td></td>
                                <td>{currency} {order.service_charge.toFixed(2)}</td>
                            </tr>
                        ) :null}

                        <tr>
                            <td colSpan="5" className="px-6 py-1 whitespace-nowrap">
                                <hr className="border-gray-400"/>
                            </td>
                        </tr>
                        <tr>
                            <td className="px-6 py-1 whitespace-nowrap">{t('Total')}</td>
                            <td></td>
                            <td></td>
                            <td>{currency} {order.total.toFixed(2)}</td>
                        </tr>
                        </tfoot>
                    ) :null}
                </table>
            </div>

        </div>
    )
}

export default ListDetailsOrder;
